<div class="container py-5">
    <div class="row">
        <div class="col-12 text-center">
            <h1>Something went wrong!</h1>
            <p>Sorry, something went wrong, please try again.</p>
        </div>
    </div>
</div>
